import {Controller} from "stimulus"

/*
 * Makes the license calculator's units inputs read-only while the
 * Freeze Units checkbox is checked, and saves the checkbox on its own.
 * The calculator only auto-saves after a valid estimate, so leaving the
 * freeze to that save could show it checked while it was never stored.
 * If the save fails the checkbox and inputs go back to the stored state.
 * The server enforces the freeze too.
 */
export default class extends Controller {
  static targets = ["toggle", "units"]

  toggle() {
    const frozen = this.toggleTarget.checked
    this.showFrozen(frozen)
    this.saveFreeze(frozen)
      .then(response => { if (!response.ok) throw new Error(`HTTP ${response.status}`) })
      .catch(() => this.undoToggle(frozen))
  }

  showFrozen(frozen) {
    this.unitsTargets.forEach(input => { input.readOnly = frozen })
  }

  saveFreeze(frozen) {
    const form = this.toggleTarget.form
    const body = new FormData()
    body.append("_method", "patch")
    body.append("bl_license_application[units_frozen]", frozen ? "1" : "0")

    return fetch(form.action, {
      method: "POST",
      body: body,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        "Accept": "application/json"
      }
    })
  }

  undoToggle(frozen) {
    this.toggleTarget.checked = !frozen
    this.showFrozen(!frozen)
    alert("Error: Could not save Freeze Units. Please try again.")
  }
}
